export default "__VITE_ASSET__B0_LVjdv__"